import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/lib/auth";

import Home from "@/pages/Home";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import Checkout from "@/pages/Checkout";
import Booking from "@/pages/Booking";
import { Help, Terms, Privacy, Refund, Shipping, Contact } from "@/pages/Policies";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/components/AdminLayout";
import WaitingRoom from "@/components/WaitingRoom";
import AdminDashboard from "@/pages/admin/Dashboard";
import CheckIn from "@/pages/admin/CheckIn";
import { AdminBookings } from "@/pages/admin/Bookings";
import { AdminEvents } from "@/pages/admin/Events";
import { Finance, Coupons, AdminSettings } from "@/pages/admin/Finance";
import { AdminWaitlist } from "@/pages/admin/Waitlist";
import { AdminCities, AdminVenues, AdminQuotes } from "@/pages/admin/Places";
import { AdminEventHandlers } from "@/pages/admin/EventHandlers";
import Impact from "@/pages/Impact";
import Portal from "@/pages/Portal";
import NotFound from "@/pages/NotFound";
import OrganizerEvents from "@/pages/OrganizerEvents";
import OfflineSales from "@/pages/admin/OfflineSales";
import OrganizerSettings from "@/pages/admin/OrganizerSettings";
import AdminOrganizers from "@/pages/admin/Organizers";

function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-center">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <WaitingRoom />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/org/:organizerSlug" element={<OrganizerEvents />} />
          <Route path="/events/:slug" element={<EventDetail />} />
          <Route path="/events/:organizerSlug/:slug" element={<EventDetail />} />
          <Route path="/checkout/:session" element={<Checkout />} />
          <Route path="/booking/:ref" element={<Booking />} />
          <Route path="/help" element={<Help />} />
          <Route path="/impact" element={<Impact />} />
          <Route path="/portal" element={<Portal />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/refund-policy" element={<Refund />} />
          <Route path="/shipping" element={<Shipping />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<RequireAuth><AdminLayout /></RequireAuth>}>
            <Route index element={<AdminDashboard />} />
            <Route path="events" element={<AdminEvents />} />
            <Route path="bookings" element={<AdminBookings />} />
            <Route path="offline-sales" element={<OfflineSales />} />
            <Route path="check-in" element={<CheckIn />} />
            <Route path="organizer-settings" element={<OrganizerSettings />} />
            <Route path="organizers" element={<AdminOrganizers />} />
            <Route path="event-handlers" element={<AdminEventHandlers />} />
            <Route path="finance" element={<Finance />} />
            <Route path="coupons" element={<Coupons />} />
            <Route path="waitlist" element={<AdminWaitlist />} />
            <Route path="cities" element={<AdminCities />} />
            <Route path="venues" element={<AdminVenues />} />
            <Route path="quotes" element={<AdminQuotes />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
